import { LNGS_NAMESPACE_LOGICAL_DEVICE, LNGS_NAMESPACE_TASKS } from '@ingenico/util-i18n-config';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export function useInitialSetup() {
  const { t, ready: isTranslationReady } = useTranslation([
    ...Object.values(LNGS_NAMESPACE_TASKS),
    LNGS_NAMESPACE_LOGICAL_DEVICE.DEFAULT,
    LNGS_NAMESPACE_LOGICAL_DEVICE.ERROR_DIAGNOSTICS,
  ]);
  const datagridRef = useGridApiRef();
  const navigate = useNavigate();

  return { t, datagridRef, navigate, isTranslationReady };
}
